exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vbF-r-E4avKj8URfLkl17{width:320px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}@media only screen and (max-width:1400px){._3LSK0fynhhkK7LzEI6gycY.vbF-r-E4avKj8URfLkl17{width:calc(100vw - 1080px);min-width:0}}", ""]);
// Exports
exports.locals = {
	"underlay": "vbF-r-E4avKj8URfLkl17",
	"shrinkable": "_3LSK0fynhhkK7LzEI6gycY"
};